(function () {
    'use strict';

    angular
        .module('app')
        .controller('header', header);

    header.$inject = ['$mdDialog', 'breadCrumbService', 'sidebarservice', '$window', 'loginService', '$state', '$localStorage', '$rootScope', '$timeout', 'searchCardService', 'gridDataService', 'fileGuideService', 'clientService', '$interval', 'sessionTimeoutService'];

    function header($mdDialog, breadCrumbService, sidebarservice, $window, loginService, $state, $localStorage, $rootScope, $timeout, searchCardService, gridDataService, fileGuideService, clientService, $interval, sessionTimeoutService) {
        /* jshint validthis:true */
        var vm = this;
        vm.title = 'header';
        vm.sidebarservice = sidebarservice;
        vm.localStorage = $localStorage;
        vm.state = $state;
        vm.inboxNode = {};
        vm.loginService = loginService;
        vm.sessionTimeoutService = sessionTimeoutService;
        vm.gridDataService = gridDataService;
        vm.clientService = clientService;
        vm.showHelpOptions = false;

        vm.toggleHelp = function() {
            vm.showHelpOptions = !vm.showHelpOptions;
        }

        vm.gotoHelp = function (type) {
            vm.showHelpOptions = false;
            switch (type) {
                case "html":
                    window.open(window.location.origin + "/Synergis.WebApi/Help/index.html");
                    break;
                case "pdf":
                    var xhr = new XMLHttpRequest();
                    xhr.open('GET', window.location.origin + "/Synergis.WebApi/Help/AdeptAWCUser.pdf", true);
                    xhr.responseType = 'blob';

                    xhr.onload = function (e) {
                        if (this.status == 200) {
                            // get binary data as a response
                            var blob = this.response;
                            processFile(this.response);
                        }
                    };
                    xhr.send();
                    break;
                case "about":
                    $mdDialog.show({
                        parent: angular.element(document.body),
                        templateUrl: 'app/header/templates/about.html',
                        controller: 'about',
                        controllerAs: 'vm',
                        fullscreen: false,
                        clickOutsideToClose: true,
                        locals: {
                            
                        }
                    });
                    break;
            }
            
        }

        var processFile = function (blob) {
            saveAs(blob, "AdeptHelp.pdf");
        }

        vm.collabPortalButtonClicked = function() {
            loginService.refreshToken().then(function(resp) {
                var access_token = resp.data.access_token;
                window.open("../collabportal/main?token=" + access_token);
            });
        }


        vm.sideBarButtonClicked = function () {
            sidebarservice.leftSideBarOpen = !sidebarservice.leftSideBarOpen;
            $localStorage.perUserSettings[loginService.id].leftSideBarOpen = sidebarservice.leftSideBarOpen;
            $timeout(function () {
                gridDataService.refreshGrid();
            }, 100);

            if (bowser.android || bowser.ios) {
                if (sidebarservice.leftSideBarOpen)
                    sidebarservice.rightSideBarOpen = false;
            }
        };

        // ******************************************
        // Information Source: WIP/Library
        // ******************************************

        var refreshGrid = function () {
            gridDataService.reloadGrid();
            //scope.gridApi.grid.handleWindowResize();
            //scope.gridApi.grid.refreshCanvas();
            //scope.gridApi.grid.refresh();
        }

        var makeWipLibraryButtonText = function () {
            var str = "";
            if (loginService.informationSourceWip) {
                str = str + loginService.resourceStrings["WIP"]; // "WIP"
                vm.infoSourceValue = true;
            }
            else {
                str = str + loginService.resourceStrings["LIBRARY"]; // "Library"
                vm.infoSourceValue = false;
            }

            vm.wipLibraryButtonText = str
        }

        vm.showSystemLog = function (ev) {
            $mdDialog.show({
                controller: 'systemlog',
                controllerAs: 'vm',
                templateUrl: 'app/systemlog/templates/systemlog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: false
            });
        }

        //loginService.initStrings().then(function () {
        loginService.getInformationSource().then(function () {
            // init
            makeWipLibraryButtonText();
            //vm.profileLabel = loginService.resourceStrings["PROFILE"]; // "Profile"
            //vm.logoutLabel = loginService.resourceStrings["LOGOUT"]; // "Log Out"
            //vm.explorerLabel = "Explorer"; // Not localized because it is part of the product name. - loginService.resourceStrings["EXPLORER"]; // "Explorer"
            //vm.reviewerLabel = "Reviewer"; // Not localized because it is part of the product name. - loginService.resourceStrings["REVIEWER"]; // "Reviewer"
        });
        //});

        //public enum ADEPT_INFORMATIONSORCE
        //{
        //    NO_SOURCE = -1,
        //    APPROVED,
        //    WIP
        //}
        vm.processingChange = false;

        vm.wipLibraryButtonClicked = function () {
            if (breadCrumbService.category == loginService.resourceStrings["INBOX"]) {
                vm.infoSourceValue = true;
                $rootScope.msgBoxShow(loginService.resourceStrings["INFO_SOURCE_WARNING"], loginService.resourceStrings["INFORMATION_SOURCE"], 0, true);
            }
            else {
                var bWip = !loginService.informationSourceWip;
                loginService.setInformationSource(bWip).then(function () {
                    makeWipLibraryButtonText();
                    refreshGrid();
                });
            }
        }

        // ******************************************

        vm.rightSideBarToggle = function () {
            vm.sidebarservice.toggleRightSidebar(0);
        };

        vm.logOut = function () {
            //we're going to trigger a state change event and have the logout controller perform the logout
            vm.showUserMenu = false;
            $state.go("layout.logout");
        };

        vm.inboxClicked = function () {
            fileGuideService.mode = 2;
            fileGuideService.getInboxTree().then(function () {
                
                var node = fileGuideService.tree[0].children[0];
                fileGuideService.title = loginService.resourceStrings["INBOX"];
                fileGuideService.showFilter = false;
                //set the function to call when an item is picked
                fileGuideService.currentAction = fileGuideService.inboxNodePicked;

                fileGuideService.nodeClicked(node);
                sidebarservice.openMenuItem(loginService.resourceStrings["INBOX"]);
            });
            
        }

        vm.showUserMenu = false;
        vm.toggleUserMenu = function () {
            makeWipLibraryButtonText();
            vm.showUserMenu = !vm.showUserMenu;
        }

        vm.iconFlash = false;
        $interval(function () {
            vm.iconFlash = !vm.iconFlash; 
        }, 500);

        vm.showUpdateIcon = true;

        vm.updateACS = function () {
            clientService.showDownloadDialog();
        }

        function activate() { }
    }
})();
